import { Component } from '@angular/core';
import * as paper from 'paper';




//var mypaper: any;
// var path: any;
// var drag = false;
 var papercanvas: HTMLCanvasElement;

@Component({
  selector: 'uitextpaint',
  templateUrl: 'uitextpaint.html'
})
export class UitextpaintComponent {

  

  constructor() {
    console.log('Hello UitextpaintComponent Component');
    
  }

ionViewDidLoad() {
    console.log("ionViewDidLoad uitextpaint");
    this.initPaper();


  }

  initPaper() {
    papercanvas = <HTMLCanvasElement>document.getElementById('uitextpaintcanvas');
    //alert(mycanvas.id)
                   // paper.install(window);
                paper.setup(papercanvas);
            }


//            public set setText(mytext: string) {

//             var text = new paper.PointText({
// 	point: paper.view.center,
// 	content: '3',
// 	justification: 'center',
// 	fontSize: 60
// });
//            }
}



// WEBPACK FOOTER //
// ./src/components/uitextpaint/uitextpaint.ts